import { render, staticRenderFns } from "./ManhattanPlot.vue?vue&type=template&id=188e8cfe&"
import script from "./ManhattanPlot.vue?vue&type=script&lang=js&"
export * from "./ManhattanPlot.vue?vue&type=script&lang=js&"
import style0 from "./ManhattanPlot.vue?vue&type=style&index=0&id=188e8cfe&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188e8cfe')) {
      api.createRecord('188e8cfe', component.options)
    } else {
      api.reload('188e8cfe', component.options)
    }
    module.hot.accept("./ManhattanPlot.vue?vue&type=template&id=188e8cfe&", function () {
      api.rerender('188e8cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ManhattanPlot.vue"
export default component.exports